(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-comparison-table"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 767) {
    const mobileImages = document.querySelectorAll('.comparison-mobile-image');
    
    mobileImages.forEach(img => {
      let currentScale = 1;
      let startDistance = 0;
      let isDragging = false;
      let startX, startY, initialX, initialY;
      let transform = {
        translateX: 0,
        translateY: 0,
        scale: 1
      };

      function setTransform() {
        img.style.transform = `translate(${transform.translateX}px, ${transform.translateY}px) scale(${transform.scale})`;
      }

      function handleGestureStart(e) {
        if (e.touches.length === 2) {
          e.preventDefault();
          startDistance = Math.hypot(
            e.touches[0].pageX - e.touches[1].pageX,
            e.touches[0].pageY - e.touches[1].pageY
          );
        } else if (e.touches.length === 1 && transform.scale > 1) {
          isDragging = true;
          startX = e.touches[0].pageX - transform.translateX;
          startY = e.touches[0].pageY - transform.translateY;
        }
      }

      function handleGestureMove(e) {
        if (e.touches.length === 2) {
          e.preventDefault();
          
          const currentDistance = Math.hypot(
            e.touches[0].pageX - e.touches[1].pageX,
            e.touches[0].pageY - e.touches[1].pageY
          );
          
          const scale = (currentDistance / startDistance) * transform.scale;
          transform.scale = Math.min(Math.max(scale, 1), 3);
          
          setTransform();
          img.classList.toggle('zoomed', transform.scale > 1);
        } else if (isDragging && e.touches.length === 1) {
          const currentX = e.touches[0].pageX;
          const currentY = e.touches[0].pageY;
          
          transform.translateX = currentX - startX;
          transform.translateY = currentY - startY;

          // Calculate boundaries
          const imgRect = img.getBoundingClientRect();
          const containerRect = img.parentElement.getBoundingClientRect();
          
          // Limit horizontal movement
          const maxX = (imgRect.width * transform.scale - containerRect.width) / 2;
          transform.translateX = Math.min(Math.max(transform.translateX, -maxX), maxX);
          
          // Limit vertical movement
          const maxY = (imgRect.height * transform.scale - containerRect.height) / 2;
          transform.translateY = Math.min(Math.max(transform.translateY, -maxY), maxY);
          
          setTransform();
        }
      }

      function handleGestureEnd() {
        isDragging = false;
        if (transform.scale === 1) {
          transform.translateX = 0;
          transform.translateY = 0;
          setTransform();
        }
      }

      // Double tap to zoom
      let lastTap = 0;
      img.addEventListener('touchend', function(e) {
        const currentTime = new Date().getTime();
        const tapLength = currentTime - lastTap;
        
        if (tapLength < 300 && tapLength > 0) {
          e.preventDefault();
          transform.scale = transform.scale === 1 ? 2 : 1;
          if (transform.scale === 1) {
            transform.translateX = 0;
            transform.translateY = 0;
          }
          setTransform();
          img.classList.toggle('zoomed', transform.scale > 1);
        }
        
        lastTap = currentTime;
      });

      img.addEventListener('touchstart', handleGestureStart, { passive: false });
      img.addEventListener('touchmove', handleGestureMove, { passive: false });
      img.addEventListener('touchend', handleGestureEnd);
      img.addEventListener('touchcancel', handleGestureEnd);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
